var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1654 21.9999C42.1654 22.6498 42.1346 23.2926 42.0744 23.9268C41.0357 22.8874 39.8194 22.0256 38.475 21.3903C38.1544 12.567 30.9004 5.51244 21.9987 5.51244C12.8929 5.51244 5.51122 12.8941 5.51122 21.9999C5.51122 30.9017 12.5658 38.1556 21.3891 38.4763C22.0244 39.8207 22.8862 41.0369 23.9255 42.0756C23.2914 42.1358 22.6486 42.1666 21.9987 42.1666C10.861 42.1666 1.83203 33.1376 1.83203 21.9999C1.83203 10.8622 10.861 1.83325 21.9987 1.83325C33.1364 1.83325 42.1654 10.8622 42.1654 21.9999Z",
    fill: "#0796A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8327 21.7823L25.3774 22.6742C24.3546 23.4304 23.448 24.3352 22.6898 25.3564L21.1146 24.4468C20.7961 24.263 20.5538 23.998 20.3983 23.6932C20.166 23.3336 20.166 22.8557 20.166 22.8557V11.0001C20.166 9.98755 20.9868 9.16675 21.9993 9.16675C23.0119 9.16675 23.8327 9.98757 23.8327 11.0001V21.7823Z",
    fill: "#0796A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0369 32.4631C28.7529 31.7472 29.9137 31.7472 30.6296 32.4631L31.805 33.6385L35.2867 30.1568C36.0028 29.4409 37.1635 29.4409 37.8794 30.1568C38.5955 30.8729 38.5955 32.0336 37.8794 32.7497L33.2223 37.4067C33.0639 37.5651 32.8839 37.6885 32.6916 37.7767C31.9894 38.1874 31.0726 38.0917 30.4705 37.4894L28.0369 35.0558C27.321 34.3399 27.321 33.1791 28.0369 32.4631Z",
    fill: "#0796A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 44C39.0751 44 44 39.0751 44 33C44 26.9249 39.0751 22 33 22C26.9249 22 22 26.9249 22 33C22 39.0751 26.9249 44 33 44ZM33 40.3665C28.9317 40.3665 25.6335 37.0684 25.6335 33C25.6335 28.9317 28.9317 25.6335 33 25.6335C37.0684 25.6335 40.3665 28.9317 40.3665 33C40.3665 37.0684 37.0684 40.3665 33 40.3665Z",
    fill: "#0796A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon5);
export default __webpack_public_path__ + "static/media/main_icon5.6931b39c8ac67974d8ca8a4e0ecc34dc.svg";
export { ForwardRef as ReactComponent };